import {
  IconLayoutDashboard,
  IconCar,
  IconRoute,
  IconUsers,
  IconCategory,
  IconRoadSign,
  IconTicket,
  IconReceipt2,
  IconReportMoney,
  IconAlertTriangle,
  IconMessages,
  IconLuggage,
  IconShieldLock,
  IconCashBanknote,
  IconFileInvoice,
  IconBuildingBank,
  IconListDetails,
  IconSettings,
  IconHistory,
  IconHome,
  IconMapPin,
  IconInbox,
  IconChartPie,
  IconChartHistogram,
  IconFileAnalytics,
  IconWallet,
  IconUserPlus,
  IconTags,
  type TablerIcon,
} from "@tabler/icons-react";
import type { ModuleKey } from "../../auth/rbac";
import type { TranslationKey } from "../../i18n/en";

export type NavSection =
  | "Command"
  | "Operations"
  | "Finance"
  | "Insights"
  | "Compliance"
  | "Support"
  | "Configuration"
  | "System";

export interface NavItem {
  module: ModuleKey;
  /** i18n key for the sidebar label. */
  labelKey: TranslationKey;
  to: string;
  icon: TablerIcon;
  section: NavSection;
  /** Extra words the header search matches on (English + Swahili). */
  keywords?: string;
}

// Single source of truth for the sidebar, route gating and header search.
// Grouped by the job someone is doing, not by database table.
export const NAV: NavItem[] = [
  { module: "home", labelKey: "nav.home", to: "/", icon: IconHome, section: "Command", keywords: "home start overview nyumbani" },
  { module: "live", labelKey: "nav.live", to: "/live", icon: IconMapPin, section: "Command", keywords: "map live dispatch real-time ramani stuck idle drivers demand" },
  { module: "inbox", labelKey: "nav.inbox", to: "/inbox", icon: IconInbox, section: "Command", keywords: "tasks todo actions queue kazi" },

  { module: "trips", labelKey: "nav.trips", to: "/trips", icon: IconRoute, section: "Operations", keywords: "rides bookings safari" },
  { module: "drivers", labelKey: "nav.drivers", to: "/drivers", icon: IconCar, section: "Operations", keywords: "drivers kyc documents approve onboarding madereva" },
  { module: "referrals", labelKey: "nav.referrals", to: "/referrals", icon: IconUserPlus, section: "Operations", keywords: "referral agents invite codes rewards rufaa mawakala" },
  { module: "users", labelKey: "nav.users", to: "/users", icon: IconUsers, section: "Operations", keywords: "riders passengers customers abiria" },
  { module: "sos", labelKey: "nav.sos", to: "/sos", icon: IconAlertTriangle, section: "Operations", keywords: "emergency panic safety dharura" },

  { module: "finance", labelKey: "nav.finance", to: "/finance", icon: IconChartPie, section: "Finance", keywords: "revenue money p&l profit gmv take rate fedha mapato" },
  { module: "transactions", labelKey: "nav.transactions", to: "/transactions", icon: IconReceipt2, section: "Finance", keywords: "payments ledger miamala" },
  { module: "payouts", labelKey: "nav.payouts", to: "/payouts", icon: IconWallet, section: "Finance", keywords: "cash-out withdrawals selcom" },
  { module: "settlements", labelKey: "nav.settlements", to: "/settlements", icon: IconCashBanknote, section: "Finance", keywords: "debt cash collect settle" },
  { module: "payout-catalogue", labelKey: "nav.payout-catalogue", to: "/payout-destinations", icon: IconListDetails, section: "Finance", keywords: "banks mobile money mpesa" },
  { module: "coupons", labelKey: "nav.coupons", to: "/coupons", icon: IconTicket, section: "Finance", keywords: "coupons discounts promo punguzo" },

  { module: "analytics", labelKey: "nav.analytics", to: "/analytics", icon: IconChartHistogram, section: "Insights", keywords: "analytics kpi fulfilment cancellations heatmap cohorts retention takwimu" },
  { module: "monthly", labelKey: "nav.monthly", to: "/reports/monthly", icon: IconFileAnalytics, section: "Insights", keywords: "monthly summary owner board report pdf print" },
  { module: "reports", labelKey: "nav.reports", to: "/reports", icon: IconReportMoney, section: "Insights", keywords: "csv export revenue reports ripoti" },
  { module: "dashboard", labelKey: "nav.dashboard", to: "/overview", icon: IconLayoutDashboard, section: "Insights", keywords: "classic dashboard totals" },

  { module: "latra", labelKey: "nav.latra", to: "/latra", icon: IconBuildingBank, section: "Compliance", keywords: "latra cets regulator remittance" },
  { module: "tax-receipts", labelKey: "nav.tax-receipts", to: "/tax-receipts", icon: IconFileInvoice, section: "Compliance", keywords: "vfd tra efd tax receipts kodi" },

  { module: "queries", labelKey: "nav.queries", to: "/queries", icon: IconMessages, section: "Support", keywords: "tickets complaints help maswali" },
  { module: "lost-items", labelKey: "nav.lost-items", to: "/lost-items", icon: IconLuggage, section: "Support", keywords: "lost found items" },

  { module: "ride-types", labelKey: "nav.ride-types", to: "/ride-types", icon: IconCategory, section: "Configuration", keywords: "pricing fares categories bei" },
  { module: "toll-locations", labelKey: "nav.toll-locations", to: "/toll-locations", icon: IconRoadSign, section: "Configuration", keywords: "tolls ushuru" },
  { module: "tags", labelKey: "nav.tags", to: "/tags", icon: IconTags, section: "Configuration", keywords: "tags labels branded identify filter lebo" },
  { module: "settings", labelKey: "nav.settings", to: "/settings", icon: IconSettings, section: "Configuration", keywords: "config booking safety commission vat mipangilio" },

  { module: "admins", labelKey: "nav.admins", to: "/admins", icon: IconShieldLock, section: "System", keywords: "staff users roles permissions wasimamizi" },
  { module: "audit", labelKey: "nav.audit", to: "/audit", icon: IconHistory, section: "System", keywords: "audit log history who changed access review" },
];

export const NAV_SECTIONS: NavSection[] = [
  "Command",
  "Operations",
  "Finance",
  "Insights",
  "Compliance",
  "Support",
  "Configuration",
  "System",
];
